// Copyright 2020
//   __  __                       _           _     _   _            _ _   _     
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__  
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \ 
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//                                                                              
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/trait/power/v1/battery_power_source.proto (package msh.trait.power.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { FloatValue, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message msh.trait.power.v1.BatteryPowerSourceTrait
 */
export const BatteryPowerSourceTrait = proto3.makeMessageType(
  "msh.trait.power.v1.BatteryPowerSourceTrait",
  [],
);

/**
 * *
 *  This enumeration represents the device resource-internal
 *  assessment of when its battery/ies should be replaced.
 *
 * @generated from enum msh.trait.power.v1.BatteryPowerSourceTrait.BatteryReplacementIndicator
 */
export const BatteryPowerSourceTrait_BatteryReplacementIndicator = proto3.makeEnum(
  "msh.trait.power.v1.BatteryPowerSourceTrait.BatteryReplacementIndicator",
  [
    {no: 0, name: "BATTERY_REPLACEMENT_INDICATOR_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "BATTERY_REPLACEMENT_INDICATOR_NOT_AT_ALL", localName: "NOT_AT_ALL"},
    {no: 2, name: "BATTERY_REPLACEMENT_INDICATOR_SOON", localName: "SOON"},
    {no: 3, name: "BATTERY_REPLACEMENT_INDICATOR_IMMEDIATELY", localName: "IMMEDIATELY"},
  ],
);

/**
 * @generated from enum msh.trait.power.v1.BatteryPowerSourceTrait.PowerSourceType
 */
export const BatteryPowerSourceTrait_PowerSourceType = proto3.makeEnum(
  "msh.trait.power.v1.BatteryPowerSourceTrait.PowerSourceType",
  [
    {no: 0, name: "POWER_SOURCE_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "POWER_SOURCE_TYPE_LINE", localName: "LINE"},
    {no: 2, name: "POWER_SOURCE_TYPE_BATTERY", localName: "BATTERY"},
  ],
);

/**
 * *
 *  This property is structured property supporting one or two
 *  representations of the amount of electric charge or energy
 *  remaining in a battery power source.
 *
 * @generated from message msh.trait.power.v1.BatteryPowerSourceTrait.Battery
 */
export const BatteryPowerSourceTrait_Battery = proto3.makeMessageType(
  "msh.trait.power.v1.BatteryPowerSourceTrait.Battery",
  () => [
    { no: 1, name: "remaining_percent", kind: "message", T: FloatValue },
    { no: 2, name: "level", kind: "message", T: FloatValue },
    { no: 3, name: "scale", kind: "message", T: FloatValue },
  ],
  {localName: "BatteryPowerSourceTrait_Battery"},
);

/**
 * *
 * Define the energy source for the device
 *
 * @generated from message msh.trait.power.v1.BatteryPowerSourceTrait.PowerSource
 */
export const BatteryPowerSourceTrait_PowerSource = proto3.makeMessageType(
  "msh.trait.power.v1.BatteryPowerSourceTrait.PowerSource",
  () => [
    { no: 1, name: "power", kind: "enum", T: proto3.getEnumType(BatteryPowerSourceTrait_PowerSourceType) },
  ],
  {localName: "BatteryPowerSourceTrait_PowerSource"},
);

/**
 * ----------- Commands ----------- //
 *
 * @generated from message msh.trait.power.v1.BatteryPowerSourceTrait.Command
 */
export const BatteryPowerSourceTrait_Command = proto3.makeMessageType(
  "msh.trait.power.v1.BatteryPowerSourceTrait.Command",
  [],
  {localName: "BatteryPowerSourceTrait_Command"},
);

/**
 * ----------- EVENTS ----------- //
 *
 * @generated from message msh.trait.power.v1.BatteryPowerSourceTrait.Event
 */
export const BatteryPowerSourceTrait_Event = proto3.makeMessageType(
  "msh.trait.power.v1.BatteryPowerSourceTrait.Event",
  [],
  {localName: "BatteryPowerSourceTrait_Event"},
);

/**
 * @generated from message msh.trait.power.v1.BatteryPowerSourceTrait.Event.BatteryChangedEvent
 */
export const BatteryPowerSourceTrait_Event_BatteryChangedEvent = proto3.makeMessageType(
  "msh.trait.power.v1.BatteryPowerSourceTrait.Event.BatteryChangedEvent",
  () => [
    { no: 1, name: "battery", kind: "message", T: BatteryPowerSourceTrait_Battery },
  ],
  {localName: "BatteryPowerSourceTrait_Event_BatteryChangedEvent"},
);

/**
 * @generated from message msh.trait.power.v1.BatteryPowerSourceTrait.Event.PowerSourceChangedEvent
 */
export const BatteryPowerSourceTrait_Event_PowerSourceChangedEvent = proto3.makeMessageType(
  "msh.trait.power.v1.BatteryPowerSourceTrait.Event.PowerSourceChangedEvent",
  () => [
    { no: 1, name: "power_source", kind: "message", T: BatteryPowerSourceTrait_PowerSource },
  ],
  {localName: "BatteryPowerSourceTrait_Event_PowerSourceChangedEvent"},
);

